import { useMemo } from 'react';
import apiClient from 'src/api/axiosClient';
import {
  BlocklistItem,
  CreateBlocklistItemRequestData,
  GetBlocklistParams,
  UpdateBlocklistItemRequestData,
  BlocklistValidateRequestData,
  BlocklistValidateResponse,
} from '../types';

export function useBlocklistApi() {
  return useMemo(
    () => ({
      getBlocklist: (params: GetBlocklistParams) => {
        return apiClient.get<{ items: BlocklistItem[]; count: number }>(`/blocklist`, { params });
      },

      createBlocklistItem: (data: CreateBlocklistItemRequestData) => {
        return apiClient.post<BlocklistItem>(`/blocklist`, data);
      },

      updateBlocklistItem: (itemId: string, data: UpdateBlocklistItemRequestData) => {
        return apiClient.put<BlocklistItem>(`/blocklist/${itemId}`, data);
      },

      deleteBlocklistItem: (itemId: string) => {
        return apiClient.delete<void>(`/blocklist/${itemId}`);
      },

      validate: (data: BlocklistValidateRequestData) => {
        return apiClient.post<BlocklistValidateResponse>(`/blocklist/validate`, data);
      },
    }),
    [],
  );
}
